import React,{Component} from 'react';
import AnalysisTools from '../../utils/AnalysisTools';
import moment from 'moment';
import { connect } from 'react-redux';
import { showError, showMessage } from '../../actions/uiActions';
import UsersApi from '../../api/users';

class RecertificationNotice extends Component {
    state={
        sending:false,
        sent:false
    }
    remind=()=>{
        this.setState({
            sending:true
        },async ()=>{
            try {
                await UsersApi.sendRecertificationReminder(this.props.account._id);
                this.props.showMessage("A reminder email has been sent to the user.");
                this.setState({
                    sending:false,
                    sent:true
                },this.props.onReminder);
            } catch(error) {
                this.setState({
                    sending:false
                },this.props.showError);
            }
        })
    }
    render() {
        let text = "";
        const idrRecertificationDate = AnalysisTools.hasIDRRecertificationPending(this.props.account);
        const pslfRecertification = AnalysisTools.hasPSLFecertificationPending(this.props.account);
        if (idrRecertificationDate) {
            text = `This user's IDR recertification is due on ${moment(idrRecertificationDate, "X").format("MM/DD/YYYY")}`;
        } else {
            text = `This user's PSLF recertification for ${pslfRecertification.employer?.employer_name || 'unknown employer'} is due on ${moment(pslfRecertification.recertificationDate, "X").format("MM/DD/YYYY")}`;
        }
        return <div className="alert alert-warning">
            {text}<b>{!this.state.sent && (!this.props.account.recertificationNotice || this.props.account.recertificationNotice < moment().subtract(2,"days").format("X"))
            && <button onClick={this.remind} disabled={this.state.sending} style={{marginLeft:"40px"}} className={`btn btn-mini ${!this.state.sending&&'btn-secondary'}`}>{this.state.sending?"Sending reminder....":"Send reminder"}</button>}</b>
        </div>;
    }
}
export default connect(null,{ showError, showMessage })(RecertificationNotice);